export type PreferredMethod =
  | 'constrained'
  | 'unconstrained'
  | 'carbonCost'
  | 'campaign'

export type Status =
  | 'completed'
  | 'failed'
  | 'unstarted'
  | 'running'
  | 'initiated'
  | 'processing'

export type BaseSourceSiteWorkCentre = {
  id: number
  baseSourceSiteKey: number
  baseSourceSiteCode: string
  workcentreCode: string
  workCentreKey: number
  workcentreCapacity: number
  headSpaceBuffer: number
  preferredTemplate: PreferredMethod
  constrainedStatus: Status
  unconstrainedStatus: Status
  carbonCostStatus: Status
  campaignStatus: Status
}

export const STATUS_MAP: Record<
  PreferredMethod,
  keyof BaseSourceSiteWorkCentre
> = {
  constrained: 'constrainedStatus',
  unconstrained: 'unconstrainedStatus',
  carbonCost: 'carbonCostStatus',
  campaign: 'campaignStatus',
}

export const createMenuItems = (list: string[]) => {
  return list.map((item) => {
    return { label: item, value: item }
  })
}

export const PREFERRED_METHODS: PreferredMethod[] = [
  'constrained',
  'unconstrained',
  'carbonCost',
  'campaign',
]

export const SUPPLY_TYPES = ['COUPLED', 'DECOUPLED']
